module.exports = __webpack_public_path__ + "media/images/icon_list/help-566b3ecd7170afad8a94c31f66facba0.svg";